import { Page, PageHeader } from "@/components/Bits";
import TreatmentRules from "@/components/TreatmentRules";

export default function TreatmentRulesPage() {
  return (
    <Page>
      <PageHeader overline="Optimisation" title="Treatment Rules"
        subtitle="Save a treatment once and auto-apply it to matching invoices and bills on every import." />
      <TreatmentRules standalone />
    </Page>
  );
}
